const initialState = {
 user: null,
};

export default initialState;
